var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Chips',{key:'ExplorerFilterChips_'+_vm.forceRender,staticClass:"qmkey-header-filter-chips",attrs:{"title":_vm.$vuetify.lang.translator('filters.advanced.filters')+': ',"items":_vm.filters_chips,"whitelist":_vm.whitelist_filters_chips,"disable":_vm.disable},on:{"update":_vm.update_filters}})
}
var staticRenderFns = []

export { render, staticRenderFns }